import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
function Plans(_ref) {
  let {
    color = colors.actionMinor[500],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.27 11.524 2.367 7.62a1.168 1.168 0 0 1-.351-.86c0-.363.117-.663.35-.897L5.88 2.351C6.114 2.117 6.4 2 6.738 2c.365 0 .664.117.898.351l1.327 1.327-2.42 2.42c-.156.13-.156.274 0 .43l.43.43a.265.265 0 0 0 .195.077c.104 0 .182-.026.234-.078l2.42-2.42 1.717 1.717-5.269 5.27Zm15.184-4.567-1.796 1.796-4.41-4.411 1.795-1.796A1.807 1.807 0 0 1 18.37 2c.52 0 .963.182 1.327.546l1.757 1.757c.364.364.546.807.546 1.327 0 .52-.182.963-.546 1.327ZM14.35 5.24l4.41 4.41L7.168 21.243l-4.177.741a.793.793 0 0 1-.741-.234.793.793 0 0 1-.234-.741l.741-4.177L14.35 5.24Zm7.299 11.124c.234.234.351.533.351.898 0 .338-.117.624-.351.858l-3.513 3.513c-.234.234-.534.351-.898.351-.338 0-.624-.117-.859-.35l-3.903-3.943 5.27-5.23 1.717 1.717-2.42 2.42c-.156.13-.156.273 0 .43l.43.429c.155.156.299.156.429 0l2.42-2.42 1.327 1.327Z",
    fill: color
  }));
}
export default Plans;